import { LINE_COLORS } from '../LineChart/constants';

export const getOptionColors = (
  options: string[],
  palette: readonly string[] = LINE_COLORS,
): Map<string, string> => {
  return new Map(
    options.map((option, index) => {
      return [option, palette[index % palette.length]];
    }),
  );
};
